var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78711 0.637666C8.27539 0.149424 9.06836 0.149424 9.55664 0.637666L10.3262 1.40778C10.8145 1.89587 10.8145 2.68806 10.3262 3.17634L9.38086 4.12165L6.84179 1.58298L7.78711 0.637666ZM8.93945 4.56306L4.38476 9.11579C4.18164 9.31892 3.92968 9.46931 3.65429 9.54938L1.3041 10.2408C1.13964 10.2896 0.961714 10.2447 0.840425 10.106C0.719132 10.0025 0.673785 9.82477 0.722183 9.65876L1.41347 7.30915C1.49472 7.03376 1.64375 6.78181 1.84707 6.57868L6.40039 2.02478L8.93945 4.56306Z",
    fill: "#36505E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.bb2e9178692dc28dc4555b2302de9dd7.svg";
export { ForwardRef as ReactComponent };